import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  margin-top: 16px;
  margin-bottom: 30px;

  .resendPinLoadingSpinner {
    width: 20px;
    height: 20px;
    border-width: 3px;
  }
`

export const WrapperText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 10px;
`